var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detect-screen-size'),_c('spinner',{attrs:{"guid":_vm.spinner.guid,"alignment":_vm.spinner.alignment}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }